import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from "@angular/router";
import { ApiService } from "../services/api.service";
import { ToastrService } from 'ngx-toastr';
import * as $ from "jquery";


//import { ToastrService } from "ngx-toastr";
// import { map } from "jquery";
// import * as $ from "jquery";
// import { from } from 'rxjs';

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.css"]
})
export class LoginComponent implements OnInit {

  loginUserData:any
  alert:boolean=false;
  email:any;
  password:any;
  loginModel:any;
  signUpModel:any;
  isShowLogin:boolean = true;
  isShowForgetPassword:boolean = false;
  isShowSignUp:boolean = false;
  isShowOtp:boolean = false;

  constructor(
    private router: Router,
    public addVideoService: ApiService,
    private toastrService:ToastrService
  ) {
    this.loginModel = {};
    this.signUpModel = {};
  }

  ngOnInit(): void {

    if(localStorage.getItem('accessToken') !=null && localStorage.getItem('userID') != null && localStorage.getItem('userName') != null)
{
  // this.router.navigate(['']);
  this.router.navigate(['']);
}
  }


  onLogin() {

    if ( this.addVideoService.isEmptyValue(this.loginModel.userID) || this.addVideoService.isEmptyValue(this.loginModel.password)) {
      this.alert=true;
      this.toastrService.error('Login Error!!');
      return;
    } else {

     var obj = {
      email:this.loginModel.userID,
      password:this.loginModel.password
     }
     console.log("SandeepSir",obj);
     $('.loading-overlay').addClass('is-active');
    // alert('vishnu');
      this.addVideoService.checkLogin(obj).subscribe((data) => {
//alert(data.responseCode);
        console.log('sandeep');
        console.log(data);
        var logindetails = data.responseValue[0];
        localStorage.setItem('accessToken',logindetails.accessToken);
        localStorage.setItem('userID',JSON.stringify(data.responseValue[0].userId));
        localStorage.setItem('userName',JSON.stringify(data.responseValue[0].name));
        this.router.navigate(['./dashboard']);
        $('.loading-overlay').removeClass('is-active');

      },

      (error) => {                              //Error callback
        console.error('error caught in component')
        this.toastrService.error('Login Error!!Check Username or Password');
        $('.loading-overlay').removeClass('is-active');

        //throw error;   //You can also throw the error to a global error handler
      }

      );
    }
  }
  onSendOtp(){

    var obj = {
    mobileNo:this.signUpModel.mobileNo,
    email:this.signUpModel.email
    }
    console.log("Vishnu",obj);
    this.addVideoService.sendOtp(obj).subscribe((data) => {
      console.log(obj);
      alert('Send otp');
      alert(data.responseMessage);



    });


    this.isShowOtp=true;
    this.isShowSignUp=false;
    this.isShowForgetPassword = false;

  }
  resendOtp(){
    var obj = {
      mobileNo:this.signUpModel.mobileNo,
      email:this.signUpModel.email
      }
      alert(JSON.stringify(obj));
    // this.addVideoService.sendOtp(obj).subscribe((data) => {
    //   console.log(obj);
    //   alert('Resend otp');
    //   alert(data.responseMessage);

    // });

  }



  showSignUp(){
    this.isShowLogin = false;
    this.isShowForgetPassword = false;
    this.isShowSignUp = true;
  }
  onSubmit(){
    var obj = {
      email:this.loginModel.email
    }
    alert("Your mailID:-  "+ JSON.stringify(this.loginModel.email));
    console.log(obj);

    this.addVideoService.forgetpassword(obj).subscribe((data) => {
      if(data.responseMessage == " Email Not Exists")
      {
        console.log("helo");

      }else
      {
        console.log("Reset your password successfully!");
      }


    });

    this.isShowLogin=true;
    this.isShowForgetPassword = false;

  }
  onSignUp(){

    console.log(JSON.stringify(this.signUpModel));
    this.addVideoService.signUp(this.signUpModel).subscribe((data) => {
      if(data.responseMessage === "success"){
        console.log(data.responseMessage);
      }
      else{
        alert("Enter Correct OTP");
      }

    });
    this.isShowLogin=true;
    this.isShowOtp=false;
    this.signUpModel = {};
    this.isShowForgetPassword = false;



  }
  showForgetPassword(){
    this.isShowForgetPassword = true;
    this.isShowLogin=false;

  }

  showLogin(){
    this.isShowLogin=true;
    this.isShowSignUp=false;
    this.isShowForgetPassword = false;
  }


}
